import { brands, DEFAULT_BRAND } from 'brands'

// Not a React hook despite its name: it is called in loops, in server.js and outside
// components. An absolute URL is built on the brand's own host, so pass the brand
// (useBrand()) wherever `absolute` is true; it defaults to VoiceArchive.
export const url = (
  locale,
  path,
  absolute = false,
  anonymous = false,
  brand = brands[DEFAULT_BRAND]
) => {
  let url = ''

  if (process.env.NODE_ENV !== 'development' && absolute) {
    url = url + (anonymous ? brand.shareBase : brand.canonicalBase)
  } else {
    url = url + '/'
  }

  url = url + locale

  if (process.env.NODE_ENV !== 'development') {
    url = url + '/voicefinder'
  }

  if (!path) {
    return url
  }

  if (path.startsWith('/')) {
    url = url + path
  } else {
    url = url + '/' + path
  }

  return url
}

export default url
